import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { TICKER_ITEMS } from '../data/tickerItems';

export default function VerticalTickerRail({ className = '' }) {
  const reduceMotion = useReducedMotion();
  const track = [...TICKER_ITEMS, ...TICKER_ITEMS];

  return (
    <aside className={`ticker-rail ${className}`.trim()} aria-hidden="true">
      <div className="ticker-rail__mask">
        <motion.div
          className={`ticker-rail__track${reduceMotion ? ' ticker-rail__track--static' : ''}`}
          initial={{ opacity: 0, x: -28 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
        >
          {track.map((item, i) => (
            <motion.div
              key={`${item.label}-${i}`}
              className="ticker-card"
              data-accent={item.accent}
              whileHover={
                reduceMotion
                  ? undefined
                  : { scale: 1.06, x: 8, transition: { type: 'spring', stiffness: 380, damping: 22 } }
              }
            >
              <span className="ticker-card__shine" aria-hidden="true" />
              <span className="ticker-card__text">{item.label}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </aside>
  );
}
